import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

import Events from 'events/events';
import SignupModal from './SignupModal';
import { dispatchEvent } from 'helpers/analytics/AnalyticsEventDispatcher';

const styles = {
  'footer-banner': 'email-signup-footer-banner',
  content: 'email-signup-content',
  title: 'email-signup-title',
  message: 'email-signup-message',
  button: 'button email-signup-button',
}

const triggerAnalytics = action => dispatchEvent('dataStateChange', { action });

class FooterBanner extends PureComponent {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    triggerAnalytics('rtb.bannerSignup');
    Events.modalWillOpen.trigger(document);
    this.setState({ showModal: true });
  }

  closeModal() {
    Events.modalWillClose.trigger(document);
    this.setState({ showModal: false });
  }

  render() {
    const title = "Be in the know";
    const message = "Get inspiration, new arrivals and the latest offers to your inbox";
    const action = "Sign me up for emails";

    return (
      <div className={styles['footer-banner']}>
        <div className={styles.content}>
          {title && <p className={styles.title}>{title}</p>}

          {message && <p className={styles.message}>{message}</p>}

          <button
            className={styles.button}
            onClick={this.openModal}
          >
            {action}
          </button>

          {this.state.showModal && (
            <SignupModal onClose={this.closeModal} />
          )}
        </div>
      </div>
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const parentNode = document.querySelector('#footer-email-signup-banner');
  if (!parentNode) return;

  ReactDOM.render(
    <FooterBanner />,
    parentNode
  );
});
